import { render, staticRenderFns } from "./statusquery.vue?vue&type=template&id=2559158f&scoped=true&"
import script from "./statusquery.vue?vue&type=script&lang=js&"
export * from "./statusquery.vue?vue&type=script&lang=js&"
import style0 from "./statusquery.vue?vue&type=style&index=0&id=2559158f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559158f",
  null
  
)

export default component.exports